import PageShell from '@/components/feature/PageShell';
import FinalCta from '@/components/feature/FinalCta';
import Hero from './components/Hero';
import ServiceSelector from './components/ServiceSelector';
import HowItWorks from './components/HowItWorks';
import ServicePhoto from './components/ServicePhoto';
import MeetTechnicians from './components/MeetTechnicians';
import WhyMendwell from './components/WhyMendwell';
import Testimonials from './components/Testimonials';
import Faq from './components/Faq';

export default function Home() {
  return (
    <PageShell overlay>
      <Hero />
      <ServiceSelector />
      <HowItWorks />
      <ServicePhoto />
      <MeetTechnicians />
      <WhyMendwell />
      <Testimonials />
      <Faq />
      <FinalCta />
    </PageShell>
  );
}